import Agent from '../api/Agent'

class AbnSearchService {
  getAbnDetails(abn: string) {
    return Agent.AbrSearch.getAbnDetails(abn)
  }

  getMatchingNames(name: string) {
    return Agent.AbrSearch.getAbnMatchingNames(name)
  }
}

export default new AbnSearchService()
